export const envConfig = {
  grpahqlEndpoint: process.env.REACT_APP_BACKEND_URL,
  store: process.env.REACT_APP_STORE,
  env: process.env.REACT_APP_ENVIRONMENT,
 };

export const cmsBlockKeys = {
  footer: "ln_gns_footer",
  helpUsGrow: "ln_gns_help_you_grow",
  contactUs: "ln_gns_contact_us_link_block",
  contactSales: "ln_gns_contact_sales_link_block",
  termsConditions: "nexis-terms",
};

export const storeCode = process.env.REACT_APP_DEFAULT_COUNTRY_CODE;

export const defaultRegions = [{ label: "No Option", value: "NA" }];

export const baseRouterPath = process.env.REACT_APP_ROUTER_BASENAME || "";

export const productKey = {
  bundle_products_category_name: "Gns Bundle Products",
  addon_category_name: "Gns Add-on Products",
  discounted_products_category_name: "Gns Bundle Products Discount",
};